export class APIUrlConstants {
  public static SHELL_EDIT = '/engagements/shellEdit';
  public static NEW_SHELL = '/engagements/shellEdit/0';
  public static NEW_SHELL_LINKEXISTING = '/engagements/shellLinkExisting/0';
  public static SHELL_LINKEXISTING = '/engagements/shellLinkExisting/';
  public static SHELL_FILTER = '/engagements/shellFilter';
  public static SHELL_LINKFILTER = '/engagements/linkFilter';
  public static SHELL_NEWACCOUNT = '/engagements/newaccount';
  public static SHELL_ISSUEREPORT = '/engagements/issuereport';
  public static SHELL_ENGPERMISSION = '/engagements/engpermission';

  public static PKICCDR = '/pkiccdr';
  public static PKICREQUESTFORM = '/pkicrequestform';
  public static LINKEXISITNG = '/shellLinkExisting';
  public static ORDEROPPFORM = '/orderOpportunityForm';
  public static LINKEXISITINGTEAMSSITE = '/linkExistingTeamsSite';
  public static CLIENT_ACCEPTANCE = '/clientacceptance';
  public static RESOURCEREQUEST = '/resourcerequest';
  public static RESOURCEREQUESTNEW = '/resourcerequest/new';
  public static CONTRACTS = '/contracts';
  public static RELATEDSHELLS = '/relatedshells';
  public static SHELLSLINKEDTEAMSSITE = '/shellsLinkedTeamsSite';
  public static NEW = '/new';
}
